(function(){
  var reduce=window.matchMedia&&window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  function ready(fn){if(document.readyState!=='loading'){fn()}else{document.addEventListener('DOMContentLoaded',fn)}}
  function trail(){
    if(reduce)return;
    [].forEach.call(document.querySelectorAll('.pp-hero'),function(h){
      if(h.querySelector('.pp-trail'))return;
      var t=document.createElement('div');t.className='pp-trail';t.setAttribute('aria-hidden','true');
      for(var i=0;i<7;i++){var s=document.createElement('span');s.className='pp-pawi';t.appendChild(s)}
      (h.querySelector('.pp-hero__content')||h).appendChild(t);
    });
  }
  var CAT='<svg viewBox="0 0 96 64" aria-hidden="true"><path class="pp-earL" d="M22 30 L26 6 L42 22 Z" fill="#c9a227"/><path d="M74 30 L70 6 L54 22 Z" fill="#c9a227"/><path d="M26 12 L28 24 L36 21 Z" fill="#f3d9a4"/><path d="M70 12 L68 24 L60 21 Z" fill="#f3d9a4"/><ellipse cx="48" cy="44" rx="32" ry="26" fill="#c9a227"/><ellipse class="pp-eye" cx="37" cy="40" rx="4" ry="5" fill="#14110f"/><ellipse class="pp-eye" cx="59" cy="40" rx="4" ry="5" fill="#14110f"/><circle cx="38.5" cy="38" r="1.3" fill="#fff"/><circle cx="60.5" cy="38" r="1.3" fill="#fff"/><path d="M45 48 h6 l-3 3 z" fill="#e58a8a"/><path d="M48 51 q-3 4 -7 2 M48 51 q3 4 7 2" stroke="#14110f" stroke-width="1.6" fill="none" stroke-linecap="round"/><path d="M20 47 h-12 M21 51 l-11 3 M76 47 h12 M75 51 l11 3" stroke="#14110f" stroke-width="1.2" stroke-linecap="round" opacity=".55"/></svg>';
  function peek(){
    var f=document.querySelector('.footer__content-bottom')||document.querySelector('.footer');if(!f||f.querySelector('.pp-peek'))return;
    f.classList.add('pp-peek-host');
    var p=document.createElement('div');p.className='pp-peek';p.title='Meow!';p.innerHTML=CAT;f.appendChild(p);
    p.addEventListener('click',function(){p.classList.add('is-wave');setTimeout(function(){p.classList.remove('is-wave')},900);burst(p)});
    if(reduce||!('IntersectionObserver' in window)){p.classList.add('is-up');return}
    new IntersectionObserver(function(e){e.forEach(function(x){p.classList.toggle('is-up',x.isIntersecting)})},{threshold:.05}).observe(f);
  }
  function burst(el){
    if(reduce||!el)return;
    var r=el.getBoundingClientRect(),cx=r.left+r.width/2,cy=r.top+r.height/2;
    for(var i=0;i<7;i++){
      var s=document.createElement('span');s.className='pp-pawi pp-burst';
      var a=(-160+i*23)*Math.PI/180,d=70+Math.random()*50;
      s.style.left=(cx-8)+'px';s.style.top=(cy-8)+'px';
      s.style.setProperty('--dx',Math.round(Math.cos(a)*d)+'px');s.style.setProperty('--dy',Math.round(Math.sin(a)*d-20)+'px');s.style.setProperty('--r',Math.round(Math.random()*60-30)+'deg');
      document.body.appendChild(s);setTimeout(function(n){return function(){n.remove()}}(s),1000);
    }
  }
  function addFx(){
    document.addEventListener('click',function(e){
      var b=e.target.closest&&e.target.closest('.product-form__submit, .pp-sticky button[type=submit], .pp-btn--gold');
      if(!b)return;
      b.classList.remove('pp-wiggle');void b.offsetWidth;b.classList.add('pp-wiggle');
      burst(b);
    },true);
  }
  ready(function(){trail();peek();addFx()});
  document.addEventListener('shopify:section:load',function(){trail();peek()});
})();
